import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "src/api";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { trackAuthError, trackEvent } from "src/util/analytics";

export const YaAuthPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = getHashParams();
    const token = hashParams.access_token;

    if (!token) {
      window.close();

      return;
    }

    API.authApi
      .authControllerYaSignIn(token)
      .then((response) => {
        // Если пользователь только что зарегистрировался, отслеживаем конверсию
        if (response.data.isNewUser) {
          // Используем существующее событие для регистрации
          trackEvent("registration_completed");
          // Отслеживаем источник регистрации
          trackEvent("registration_from_yandex");

          navigate(RoutesPaths.AUTH.FINALY_REG);
        } else {
          // Отслеживаем успешную авторизацию через Яндекс
          trackEvent("yandex_auth_completed");
        }
      })
      .catch((error) => {
        // Отслеживаем ошибки авторизации через Яндекс
        trackAuthError("yandex_failed", {
          errorMessage:
            error instanceof Error ? error.message : "Unknown error",
        });
        window.close();
      });
  }, [navigate]);

  return <>Авторизация...</>;
};

function getHashParams(): Record<string, string> {
  const hashParams: Record<string, string> = {};
  const plusRegex = /\+/g;
  const paramRegex = /([^&;=]+)=?([^&;]*)/g;

  const decode = (s: string): string =>
    decodeURIComponent(s.replace(plusRegex, " "));

  const queryString = window.location.hash.substring(1);
  let match: RegExpExecArray | null;

  while ((match = paramRegex.exec(queryString)) !== null) {
    const key = decode(match[1]);
    const value = decode(match[2]);
    hashParams[key] = value;
  }

  return hashParams;
}
